// Outils communs aux fenêtres modales du thème (« Parler à un commercial », vidéo) : ouverture
// et fermeture animées (maquette « 30 sept » : voile en fondu 240 ms, panneau `leadIn` 360 ms,
// feuille qui monte du bas sur mobile), piège du focus, verrou du défilement, glisser vers le bas
// pour fermer la feuille mobile. Les animations elles-mêmes sont en CSS (layout/_modale.scss).

const FOCUSABLE = [
  'a[href]',
  'button:not([disabled])',
  'input:not([disabled]):not([type="hidden"])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'video[controls]',
  '[tabindex]:not([tabindex="-1"])'
].join(',')
const CLOSE_DURATION = 240 // ms, durée de l'animation de sortie
const SWIPE_CLOSE = 110 // px tirés vers le bas au-delà desquels la feuille se ferme
const OPEN_CLASS = 'anima-modale-open'

export const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches

const anyOpen = () => document.querySelector('.anima-modale.is-open') !== null

export const openDialog = (dialog) => {
  dialog.hidden = false
  dialog.classList.remove('is-closing')
  // Force le calcul du style avant la classe : l'animation d'entrée repart à chaque ouverture.
  dialog.getBoundingClientRect()
  dialog.classList.add('is-open')
  document.documentElement.classList.add(OPEN_CLASS)
}

export const closeDialog = (dialog, done) => {
  dialog.classList.remove('is-open')
  dialog.classList.add('is-closing')
  const finish = () => {
    dialog.hidden = true
    dialog.classList.remove('is-closing')
    if (!anyOpen()) {
      document.documentElement.classList.remove(OPEN_CLASS)
    }
    if (done) {
      done()
    }
  }
  if (reducedMotion()) {
    finish()
  } else {
    setTimeout(finish, CLOSE_DURATION)
  }
}

// Tab et Maj+Tab restent dans la fenêtre ouverte.
export const trapFocus = (dialog, e) => {
  if (e.key !== 'Tab') {
    return
  }
  const items = [...dialog.querySelectorAll(FOCUSABLE)].filter((el) => el.offsetParent !== null)
  if (!items.length) {
    return
  }
  const first = items[0]
  const last = items[items.length - 1]
  if (e.shiftKey && document.activeElement === first) {
    e.preventDefault()
    last.focus()
  } else if (!e.shiftKey && document.activeElement === last) {
    e.preventDefault()
    first.focus()
  }
}

// Feuille mobile : la poignée suit le doigt vers le bas ; au-delà du seuil la fenêtre se ferme,
// sinon elle revient en place.
export const swipeToClose = (handle, panel, close) => {
  let startY = null
  let dy = 0
  handle.addEventListener('touchstart', (e) => {
    startY = e.touches[0].clientY
    dy = 0
    panel.style.transition = 'none'
  }, {
    passive: true
  })
  handle.addEventListener('touchmove', (e) => {
    if (startY === null) {
      return
    }
    dy = Math.max(0, e.touches[0].clientY - startY)
    panel.style.transform = `translateY(${dy}px)`
  }, {
    passive: true
  })
  handle.addEventListener('touchend', () => {
    panel.style.transition = ''
    panel.style.transform = ''
    if (dy > SWIPE_CLOSE) {
      close()
    }
    startY = null
  })
}
